import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function StoreQuiz() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [answers, setAnswers] = useState({});
  const totalSteps = 4;

  // Definizione di tutte le domande del quiz
  const quizSteps = [
    {
      question: 'Qual è il tuo stile preferito?',
      options: [
        { id: 'casual', emoji: '👕', label: 'Casual' },
        { id: 'elegante', emoji: '👔', label: 'Elegante' },
        { id: 'sportivo', emoji: '👟', label: 'Sportivo' }
      ]
    },
    {
      question: 'Per quale occasione cerchi un outfit?',
      options: [
        { id: 'quotidiano', emoji: '☀️', label: 'Quotidiano' },
        { id: 'lavoro', emoji: '💼', label: 'Lavoro' },
        { id: 'evento', emoji: '🎉', label: 'Evento' }
      ]
    },
    {
      question: 'Quale gamma di colori preferisci?',
      options: [
        { id: 'chiari', emoji: '⚪', label: 'Chiari' },
        { id: 'scuri', emoji: '⚫', label: 'Scuri' },
        { id: 'vivaci', emoji: '🌈', label: 'Vivaci' }
      ]
    },
    {
      question: 'Come preferisci vestire?',
      options: [
        { id: 'aderente', emoji: '🎯', label: 'Aderente' },
        { id: 'comodo', emoji: '☁️', label: 'Comodo' },
        { id: 'oversize', emoji: '🎈', label: 'Oversize' }
      ]
    }
  ];

  const currentQuestion = quizSteps[currentStep - 1];

  const handleOptionSelect = (optionId) => {
    // Salva la risposta
    setAnswers({
      ...answers,
      [currentStep]: optionId
    });

    // Se è l'ultima domanda, vai alla pagina camera
    if (currentStep === totalSteps) {
      console.log('Quiz completed! Answers:', { ...answers, [currentStep]: optionId });
      navigate('/store-camera');
    } else {
      // Altrimenti passa alla domanda successiva
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    } else {
      navigate('/');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header con back button e progress */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 24px',
          backgroundColor: '#f5f5f5'
        }}
      >
        <IconButton
          onClick={handleBack}
          sx={{
            color: 'rgb(51, 51, 51)',
            padding: 0,
            width: '48px',
            height: '48px'
          }}
        >
          <ArrowBackIcon />
        </IconButton>

        <Typography
          sx={{
            fontSize: '14px',
            color: 'rgb(51, 51, 51)',
            fontWeight: 500
          }}
        >
          {currentStep}/{totalSteps}
        </Typography>
      </Box>

      {/* Main content */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px',
          backgroundColor: '#ffffff'
        }}
      >
        {/* Question */}
        <Typography
          component="h2"
          sx={{
            fontSize: '28px',
            fontWeight: 700,
            color: 'rgb(0, 0, 0)',
            textAlign: 'center',
            marginBottom: '48px'
          }}
        >
          {currentQuestion.question}
        </Typography>

        {/* Options */}
        <Box
          sx={{
            display: 'flex',
            gap: '24px',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}
        >
          {currentQuestion.options.map((option) => (
            <Button
              key={option.id}
              onClick={() => handleOptionSelect(option.id)}
              sx={{
                width: '176px',
                height: '144px',
                padding: '32px 24px',
                backgroundColor: 'rgb(255, 255, 255)',
                color: 'rgb(0, 0, 0)',
                border: '2px solid rgb(224, 224, 224)',
                borderRadius: '16px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgb(245, 245, 245)',
                  border: '2px solid rgb(0, 0, 0)',
                  transform: 'scale(1.02)'
                }
              }}
            >
              <Typography
                sx={{
                  fontSize: '48px',
                  lineHeight: 1
                }}
              >
                {option.emoji}
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 500,
                  color: 'rgb(0, 0, 0)'
                }}
              >
                {option.label}
              </Typography>
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default StoreQuiz;
